import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useApi, errMsg, inr } from "@/lib/api";

export const AdjustDialog = ({ member, onClose, onDone }) => {
  const api = useApi();
  const [action, setAction] = useState("credit");
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api("post", `/admin/members/${member.user_id}/adjust`, { action, amount: Number(amount), note });
      toast.success(action === "credit" ? "Money added" : "Money deducted");
      setAmount(""); setNote(""); onDone(); onClose();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-[#1F293D] bg-[#111827]" data-testid="adjust-wallet-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Wallet · {member?.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-400">Current balance <span className="font-mono text-white">{inr(member?.wallet)}</span></p>
        <div className="grid grid-cols-2 gap-2">
          {["credit", "debit"].map((a) => (
            <button key={a} onClick={() => setAction(a)} data-testid={`adjust-action-${a}`}
              className={`rounded-lg border py-2 text-sm transition-colors ${action === a ? (a === "credit" ? "border-emerald-500 bg-emerald-500/10 text-emerald-400" : "border-red-500 bg-red-500/10 text-red-400") : "border-[#1F293D] text-slate-400"}`}>
              {a === "credit" ? "Add money" : "Deduct money"}
            </button>
          ))}
        </div>
        <Input data-testid="adjust-amount-input" type="number" min={1} placeholder="Amount (₹)" value={amount} onChange={(e) => setAmount(e.target.value)} />
        <Input data-testid="adjust-note-input" placeholder="Note shown in member's history (e.g. Cash received)" value={note} onChange={(e) => setNote(e.target.value)} />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="adjust-cancel-btn">Cancel</Button>
          <Button onClick={save} disabled={busy || !(Number(amount) > 0) || note.trim().length < 2} data-testid="adjust-save-btn"
            variant={action === "debit" ? "destructive" : "default"}>{busy ? "Saving…" : action === "credit" ? "Add to wallet" : "Deduct from wallet"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
